import styled from "styled-components";

export const Label = styled.label`
    color: #ffffff;
    font-weight: bold;
    font-size: 1.5rem;
`

export const ContentProgressBar = styled.div`
   
`

export const ContainerHabilities = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 2rem;
    padding: 0 5rem 2.5rem;
`